import type { SVGProps } from "react";
export interface PizzaSliceIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PizzaSliceIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PizzaSliceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.328 6.319a1.125 1.125 0 0 1 1.391.58l.044.105.176.467c.926 2.318 2.536 4.332 4.389 6.214 1.838 1.867 3.866 3.46 6.193 4.379l.469.174.107.044a1.124 1.124 0 0 1-.737 2.114l-.111-.034-.552-.205c-2.369-.934-4.402-2.434-6.173-4.109l-.8-.784c-1.938-1.968-3.787-4.235-4.875-6.96l-.207-.55-.033-.111c-.135-.554.17-1.13.719-1.324m10.312 5.814a1.375 1.375 0 1 1-1.508 1.507l-.006-.14.006-.14a1.375 1.375 0 0 1 1.368-1.235zm-3.999-4A1.375 1.375 0 1 1 9.133 9.64l-.008-.14.008-.141A1.376 1.376 0 0 1 10.5 8.125zm5.5-1.5a1.375 1.375 0 1 1-1.51 1.508L14.627 8l.006-.141A1.376 1.376 0 0 1 16 6.625l.14.007Z"
      />
      <path
        fill={color}
        d="M20.482.939c1.55-.396 2.974 1.027 2.578 2.578l-.045.157-5.792 17.377c-.485 1.453-2.06 2.486-3.697 1.918-2.956-1.026-5.396-2.95-7.46-5.047-1.918-1.95-3.75-4.196-4.825-6.898l-.205-.546c-.576-1.64.46-3.216 1.913-3.7L20.327.986zM3.662 8.912c-.462.154-.596.557-.503.82.874 2.489 2.554 4.624 4.51 6.611 1.94 1.971 4.096 3.633 6.595 4.5.267.093.671-.044.825-.504L20.8 3.198z"
      />
    </svg>
  );
}
